import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const CalendarScheduleTime = (
  props: MyIconProps,
): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M7.49813 2.99609V5.99734" />
      <path d="M16.5019 2.99609V5.99734" />
      <path d="M9.99917 21.0039H5.9975C4.33996 21.0039 2.99625 19.6602 2.99625 18.0027V7.49832C2.99625 5.84078 4.33996 4.49707 5.9975 4.49707H18.0025C19.66 4.49707 21.0037 5.84078 21.0037 7.49832V9.99936" />
      <path d="M16.3948 14.9844V16.7431L17.7774 17.5865" />
      <path d="M16.5019 21.0037C15.3079 21.0037 14.1628 20.5295 13.3185 19.6853C12.4742 18.841 12 17.6959 12 16.5019C12.037 14.0295 14.0335 12.0348 16.5059 12C18.1142 12.0007 19.6001 12.8594 20.4036 14.2527C21.2072 15.6459 21.2064 17.362 20.4016 18.7545C19.5968 20.1471 18.1102 21.0045 16.5019 21.0037" />
    </svg>
  );
};
